<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="500px"
      append-to-body
      @close="closeDialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="维修费用类型" prop="repairPriceType">
          <el-select v-model="form.repairPriceType">
            <el-option
              v-for="(item, index) in repairExpenseTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">通过</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'repairTypeDialog',
    data() {
      return {
        title: '',
        form: {
          repairPriceType: '',
        },
        visible: false,
        repairExpenseTypeList: [],
      };
    },
    mounted() {
      this.repairExpenseTypeList = this.dictListMap?.repairExpenseType;
    },
    computed: {
      rules() {
        return {
          repairPriceType: [{ required: true, message: '维修费用类型必填' }],
        };
      },
    },
    methods: {
      openDialog() {
        this.visible = true;
      },
      // changeHandle(val){
      //     console.log('changeHandle',val,this.form.repairPriceType)
      // },
      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$emit('getRepairPriceType', this.form.repairPriceType);
          } else {
            this.$message.error('维修费用必填');
          }
        });
      },
      cancel() {
        this.visible = false;
      },
      closeDialog() {
        this.visible = false;
        console.log('关闭');
        this.$refs.form.resetFields();
        // this.$emit('repairPriceType',this.form.repairPriceType)
      },
    },
  };
</script>

<style></style>
